import {useEffect, useRef, useState} from "react";

export const useAnimatedCounter = (targetValue: number, duration: number = 500) => {
    const [currentValue, setCurrentValue] = useState(targetValue);
    const requestRef = useRef<number>();

    useEffect(() => {
        const startTimestamp = performance.now();
        const initialValue = currentValue;

        const animate = (timestamp: number) => {
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            const newValue = initialValue + (targetValue - initialValue) * progress;
            setCurrentValue(Math.round(newValue));

            if (progress < 1) {
                requestRef.current = requestAnimationFrame(animate);
            }
        };

        requestRef.current = requestAnimationFrame(animate);

        return () => {
            if (requestRef.current) {
                cancelAnimationFrame(requestRef.current);
            }
        };
    }, [targetValue, duration]);

    return currentValue;
};